/**
 * 心情 事件 定义
 * @constructor
 */
import {EventUserEntity} from "../manager/NormalGameManager";

export default function MoodEventConfig() : EventUserEntity[] {
    //数据  数组定义
    const dataArrayDefine : EventUserEntity[] = [
        // {
        //     id : 1,
        //     startValue:60,
        //     endValue:80,
        //     weight: 100,
        //     desc:"心情有点糟糕，钱包不消息掉了，钱没了",
        //     effectParams : { key:0 ,value : -10000000 }
        // },
        // {
        //     id : 2,
        //     startValue:0,
        //     endValue:60,
        //     weight: 100,
        //     desc:"心情很不好，干啥都不顺心，抑郁了，健康值扣30",
        //     effectParams : { key:2 ,value : -30 }
        // },
    ];

    return dataArrayDefine;
}


/**
 * 获取可用的事件
 * @param currMoodValue 当前心情值
 * @param filterIdArray 过滤的id集合
 */
export function getCanMoodEventList( currMoodValue : number ,filterIdArray : number[] ){
    return MoodEventConfig().filter( ( item , index, dataList )=>{
        return item.startValue < currMoodValue && item.endValue > currMoodValue && !filterIdArray.includes( item.id );
    });

}